var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-card-field",class:_vm.campoClasses,style:(_vm.cssVars)},[_c('label',{staticClass:"grid-card-field__label"},[_vm._v(_vm._s(_vm.label))]),_c('strong',{staticClass:"grid-card-field__valor"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.valorFormatado))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }